"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const lru_cache_1 = __importDefault(require("lru-cache"));
const DEFAULT_MAX = 10;
const hoist = (fn, resultFn) => {
    Object.entries(fn).forEach(([key, value]) => {
        // eslint-disable-next-line no-param-reassign
        resultFn[key] = value;
    });
};
const memoize = (fn, { max, maxAge, keyGen = (...args) => args, } = {}) => {
    const cache = new lru_cache_1.default({
        max: typeof maxAge === 'undefined' ? max || DEFAULT_MAX : undefined,
        maxAge,
        stale: false,
        updateAgeOnGet: true,
    });
    const memoized = (...args) => {
        const argsKey = keyGen(...args);
        const callKey = cache
            .keys()
            .find((callArgs) => argsKey.length === callArgs.length &&
            callArgs.every((callArg, index) => callArg === argsKey[index]));
        if (callKey) {
            const result = cache.get(callKey);
            // check for stale: true
            if (result) {
                return result;
            }
        }
        const result = fn(...args);
        cache.set(argsKey, result);
        return result;
    };
    hoist(fn, memoized);
    return memoized;
};
exports.default = memoize;
